import { useState } from 'react';

import type ProductDetailsType from '../../types/ProductDetailsType';
import Breadcrumbs from '../layout/Breadcrumbs';

import styles from './ProductTop.module.scss';

interface Props {
  product: ProductDetailsType;
}
const ProductTop: React.FC<Props> = ({ product }) => {
  const [activeVariant, setActiveVariant] = useState(product.variants[0]);

  return (
    <div className={styles.productTop}>
      <div className="container">
        <Breadcrumbs
          items={[
            ['Strona główna', '/'],
            ['Produkty', '/katalog'],
            product.category && [
              product.category.name,
              `/katalog/${product.category.slug}`,
            ],
            product.name,
          ]}
        />

        <div className={styles.productTopLayout}>
          <div className={styles.productDetails}>
            {product.category.logo_url && (
              <img
                src={product.category.logo_url}
                alt=""
                className={styles.productCategory}
              />
            )}
            <h2 className={styles.productName}>{product.name}</h2>
            <h3 className={styles.productVariant}>{product.variant_name}</h3>

            {product.viscosity ? (
              <div className={styles.productDetail}>
                <strong>Lepkość:</strong> {product.viscosity}
              </div>
            ) : null}
            {product.variants.length > 0 ? (
              <div className={styles.productDetail}>
                <strong>Warianty:</strong>

                <div className={styles.productCapacities}>
                  {(product.variants || []).map((variant) => (
                    <button
                      key={variant.id}
                      type="button"
                      title={variant.capacity}
                      onClick={() => setActiveVariant(variant)}
                      className={
                        variant.id === activeVariant?.id
                          ? styles.productCapacityCurrent
                          : ''
                      }
                    >
                      {variant.capacity}
                    </button>
                  ))}
                </div>
              </div>
            ) : null}
            {product.specification_url ? (
              <a
                href={product.specification_url}
                className={styles.productDoc}
                target="_blank"
                rel="noreferrer"
              >
                Karta katalogowa PDF (pobierz)
              </a>
            ) : null}
            {product.security_card_url ? (
              <a
                href={product.security_card_url}
                className={styles.productDoc}
                target="_blank"
                rel="noreferrer"
              >
                Karta bezpieczeństwa (pobierz)
              </a>
            ) : null}
            {product.other_attachment_url ? (
              <a
                href={product.other_attachment_url}
                className={styles.productDoc}
                target="_blank"
                rel="noreferrer"
              >
                Załącznik (pobierz)
              </a>
            ) : null}
          </div>
          <div className={styles.productImage}>
            {activeVariant?.image_url ? (
              <img src={activeVariant.image_url} alt={activeVariant.capacity} />
            ) : null}
            {!activeVariant?.image_url && product.image_url ? (
              <img src={product.image_url} alt={product.name} />
            ) : null}
          </div>
          <div
            className={styles.productDescription}
            dangerouslySetInnerHTML={{ __html: product.properties || '' }}
          />
        </div>
      </div>
    </div>
  );
};

export default ProductTop;
